<template>
  <div>
    <!-- 面包屑导航 -->
<!--    <el-breadcrumb separator-class="el-icon-arrow-right">-->
<!--      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>-->
<!--      <el-breadcrumb-item>车辆等级评定费</el-breadcrumb-item>-->
<!--    </el-breadcrumb>-->
    <!-- 卡片 -->
    <el-tabs type="border-card">
      <el-tab-pane label="车辆等级评定费"><gradeFee></gradeFee></el-tab-pane>
      <el-tab-pane label="评定(审核)人列表"><assessorList></assessorList></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import eTable from "../common/eTable.vue";
import moment from 'moment';    //日期时间转换
import eCar from "../common/eCar";
import shopCompanyTemp from "../common/shopCompanyTemp.vue";
import carListTemp from "../common/carlistTemp.vue";
import assessorList from "../common/assessorList.vue";
import gradeFee from "../common/gradeFee.vue";
export default {
  name: "shipCompany",
  components: {
    eTable,
    eCar,
    shopCompanyTemp,
    carListTemp,
    assessorList,
    gradeFee
  },
  props: {},
  data() {
    return {
      //auditData:[],
    };
  },
  created() {
    //this.getAuditData()
  },
  methods:{
    /*
    getAuditData() {
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      this.$axios.getAssessor(param).then(res=>{
        if(res.code == 200){
          ////console.log(res.data.data);
          this.auditData = res.data.data
          //return res.data.data
        }
      }).catch(error=>{
       // return
        //console.log(error);
      })
    },
    */
  }
};
</script>
<style>
.table_name{
  font-weight: bold;
  /* border: 1px solid #f00; */
}
.table_name:hover{
  color: #409EFF;
  cursor: pointer;
}
.el-breadcrumb{
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/fee/feeDictList.vue